import React from "react";
import { AnimatePresence } from "framer-motion";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/modal";
import { Button } from "@heroui/button";

import { RequestItem } from "./RequestItem";

import { useRequests } from "@/features/Admin/Admin.api";
import { SuspenseFallback } from "@/lib/Utils.Components";
import AdminAnimalUpdate from "@/features/Admin/Admin-Animal-Update.tsx";
// import AdminAnimalUpdate from "@/features/Admin/Admin-Animal-Update.tsx";

export const RequestList = ({ setShowRequests }: any) => {
  const { data, isLoading, refetch } = useRequests();
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  React.useEffect(() => {
    if (data && data.length > 0) {
      // Add a condition to avoid unnecessary refetches
      refetch();
      // console.log("Data updated:", data);
    }
  }, [data, refetch]);

  if (isLoading) {
    return <SuspenseFallback />;
  }

  return (
    <>
      <div className="max-w-md mx-auto space-y-4 p-4">
        <h2 className="text-2xl font-bold text-primary mb-4 dark:text-amber-300">
          Request Notifications
        </h2>
        <AnimatePresence>
          {data &&
            data.map((request: any) => (
              <>
                <RequestItem
                  gn={request.gn}
                  animalData={request.requestedChanges}
                  status={request.status}
                  timestamp={request.createdAt}
                  type={request.type}
                  onOpen={onOpen}
                  setShowRequests={setShowRequests}
                />
                <Modal
                  isOpen={isOpen}
                  scrollBehavior={"inside"}
                  size={"5xl"}
                  onOpenChange={onOpenChange}
                >
                  <ModalContent>
                    {(onClose) => (
                      <>
                        <ModalHeader className="flex flex-col gap-1">
                          Modal Title
                        </ModalHeader>
                        <ModalBody>
                          <AdminAnimalUpdate
                            data={request.requestedChanges}
                            id={request.animalId}
                          />
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="danger"
                            variant="light"
                            onPress={onClose}
                          >
                            Close
                          </Button>
                          <Button color="primary" onPress={onClose}>
                            Action
                          </Button>
                        </ModalFooter>
                      </>
                    )}
                  </ModalContent>
                </Modal>
              </>
            ))}
        </AnimatePresence>
      </div>
    </>
  );
};
